/**
 * 清洗客户端上报用字符串：去除换行符、回车符并 trim，避免入库超长或格式异常
 */
export function sanitizeForClientReport(s: string | null | undefined): string {
  if (s == null || typeof s !== 'string') return '';
  return s.replace(/\r/g, '').replace(/\n/g, '').trim();
}

export function truncateToLength(input: string, maxLen: number): string {
  if (maxLen <= 0) return '';
  if (input.length <= maxLen) return input;
  return input.slice(0, maxLen);
}

/**
 * 客户端上报字段最大长度，与 client_operation_report 表定义一致，超过再截取
 * 仅 report_key、bar_code 为 500；op_type/device_id/client_ip 为 64/128/64
 */
export const CLIENT_REPORT_MAX_LEN_MAP = {
  reportKey: 500,
  opType: 64,
  barCode: 500,
  deviceId: 128,
  clientIp: 64
} as const;

/**
 * 清洗并按表字段最大长度截断，用于客户端上报
 */
export function sanitizeAndTruncateForClientReport(
  s: string | null | undefined,
  maxLen: number
): string {
  return truncateToLength(sanitizeForClientReport(s), maxLen);
}

export function safeJsonStringify(value: unknown): string {
  try {
    return JSON.stringify(value);
  } catch (e) {
    return JSON.stringify({ error: 'json_stringify_failed', message: String(e) });
  }
}

export function hash32(input: string): string {
  let hash = 0;
  for (let i = 0; i < input.length; i += 1) {
    hash = ((hash << 5) - hash) + input.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(36);
}

/**
 * 获取客户端IP地址
 * 注意：浏览器环境下无法直接获取客户端IP，此函数返回 undefined
 * 实际IP地址应由后端从请求头中获取（X-Forwarded-For, X-Real-IP等）
 */
export function getClientIp(): string | undefined {
  // 浏览器环境下无法直接获取客户端IP
  // 实际IP应由后端从请求头中获取
  return undefined;
}


